declare const __AXIOM_PUBLIC_ENV__: Record<string, string | undefined>;

const browserValues = typeof __AXIOM_PUBLIC_ENV__ === "undefined" ? {} : __AXIOM_PUBLIC_ENV__;
const serverValues = typeof process === "undefined" ? {} : process.env;

function value(viteName: string, legacyName?: string): string | undefined {
  return browserValues[viteName] || serverValues[viteName] || (legacyName ? serverValues[legacyName] : undefined);
}

export const publicEnv = {
  get appUrl() { return value("VITE_APP_URL", "NEXT_PUBLIC_APP_URL"); },
  get googleClientId() { return value("VITE_GOOGLE_CLIENT_ID", "NEXT_PUBLIC_GOOGLE_CLIENT_ID"); },
  get s3ImagesUrl() { return value("VITE_S3_IMAGES_URL", "NEXT_PUBLIC_S3_IMAGES_URL"); },
  get s3SiteContentUrl() { return value("VITE_S3_SITE_CONTENT_URL", "NEXT_PUBLIC_S3_SITE_CONTENT_URL"); },
  get synapticApiUrl() { return value("VITE_SYNAPTIC_API_URL", "NEXT_PUBLIC_SYNAPTIC_API_URL"); },
  get synapticPortalUrl() { return value("VITE_SYNAPTIC_PORTAL_URL", "NEXT_PUBLIC_SYNAPTIC_PORTAL_URL"); },
  get synapticTenant() { return value("VITE_SYNAPTIC_TENANT", "NEXT_PUBLIC_SYNAPTIC_TENANT"); },
  get isDevelopment() {
    return (browserValues.MODE || serverValues.NODE_ENV || "development") !== "production";
  },
};
